import jsSHA from "jssha";

export const generateNonce = () => {
  const array = new Uint8Array(10);
  window.crypto.getRandomValues(array);

  const shaObj = new jsSHA("SHA-256", "UINT8ARRAY");
  shaObj.update(array);
  return shaObj.getHash("B64");
};
